import axios from 'axios';
import { dispatch } from 'nike-re-framejs';
import Immutable, { fromJS, Map } from 'immutable';

export const setBetradarWidgetLoaded = (tab, state) => db =>
    db.setIn(['infocentrum', 'detail', 'widgetLoaded', tab], state);

export const setBetradarLibLoaded = (tab, state) => db =>
    db.setIn(['infocentrum', 'detail', 'loaded'], true).setIn(['infocentrum', 'detail', 'widgetLoaded', tab], state);

export const checkEventCentreAllowed = tournamentId => db => {
    axios.get('/api/live-stream/event-centre-allowed/' + tournamentId).then(response => {
        dispatch(setEventCentreAllowed(response));
    });

    return db;
};

export const setEventCentreAllowed = isAllowed => db =>
    db.setIn(['infocentrum', 'detail', 'eventCentreAllowed'], fromJS(isAllowed));

export const loadMatchtrackerTemplates = db => {
    if (
        !localStorage.getItem('mtTemplatesHash') ||
        localStorage.getItem('mtTemplatesHash') !== window.OPTIONS['mtTemplatesHash']?.toString() ||
        !localStorage.getItem('mtTemplates')
    ) {
        axios.get('/api/cake-cms/betradar/mt-templates').then((response: any) => {
            localStorage.setItem('mtTemplatesHash', response.hash.toString());
            localStorage.setItem('mtTemplates', JSON.stringify(response.templates));
            dispatch(saveMatchtrackerTemplates(Map(Immutable.fromJS(response.templates))));
        });
    } else {
        dispatch(saveMatchtrackerTemplates(Map(Immutable.fromJS(JSON.parse(localStorage.getItem('mtTemplates'))))));
    }

    return db;
};

const saveMatchtrackerTemplates = templates => db => {
    return db.setIn(['infocentrum', 'templates'], templates);
};
